export const SKIP_REASONS = [];

export const HEADER_HEIGHT = 52;
export const RESULTS_SIDEBAR_WIDTH = 300;

export const PRODUCT_ASSOCIATION_MODEL_ID =
  "019a9d6b-8163-332c-f909-d83795fa82d1";
